// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueSweetalert2 from 'vue-sweetalert2';
import { store } from './store/store';
import { HTTP } from './http-common';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import VeeValidate from 'vee-validate';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

let isSubscribed = false;
let swRegistration = null;

Vue.use(VueSweetalert2);
Vue.use(VeeValidate);
Vue.config.productionTip = false;

Bugsnag.start({ apiKey: '8d1a43fa0adbd0ade93e4d8986c2a892', plugins: [new BugsnagPluginVue()] });
Bugsnag.getPlugin('vue') .installVueErrorHandler(Vue);

Vue.prototype.$pusher = new Pusher(process.env.PUSHER_KEY, {
  authEndpoint: process.env.PUSHER_AUTH_URL + '/pusher/auth',
  cluster: 'mt1',
});

Vue.prototype.$pusher.connection.bind('error', function (err) {
  if (err.error.data.code === 4004) {
    log('>>> detected limit error');
  }
  var userObj = localStorage.getItem('user_obj');
  var errObj = {};
  var userId = 0;
  if (userObj && userObj != null) {
    var userJson = JSON.parse(userObj);
    userId = userJson['id'];
  }
  errObj['error'] = err.error;
  errObj['user_id'] = userId;

  Bugsnag.notify(new Error(JSON.stringify(errObj)));
  $.ajax({
    url: process.env.ROOT_API + '/store-pusher-log',
    type: 'POST',
    data: { error: JSON.stringify(errObj) },
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": "Bearer " + localStorage.getItem("tkn"),
      "Access-Control-Allow-Headers":
        "Origin, Content-Type, Authorization,X-Requested-With",
      "Cache-Control": "no-cache"
    },
    dataType: "json",
    success: function (response) {
      // console.log(response);
    }.bind(this)
  })
});

Vue.prototype.$pusher.connection.bind('state_change', function (states) {
  // states = {previous: 'oldState', current: 'newState'}
  console.log("Channels current state is " + states.current);
  $.ajax({
    url: process.env.ROOT_API + '/store-pusher-log',
    type: 'POST',
    data: { state: states.current },
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": "Bearer " + localStorage.getItem("tkn"),
      "Access-Control-Allow-Headers":
        "Origin, Content-Type, Authorization,X-Requested-With",
      "Cache-Control": "no-cache"
    },
    dataType: "json",
    success: function (response) {
      // console.log(response);
    }.bind(this)
  })
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

/**
 * First we check if the Browser supports Notification
 * If yes, we initialize Service Worker
 * If no, no need to do anything
 */

if (('Notification' in window)) {
  console.log('Web Notification is supported');
  if (Notification.permission === "granted") {
    initServiceWorker();
  } else if (Notification.permission !== 'denied' || Notification.permission === "default") {
    Vue.swal({
      title: '',
      text: 'Please Allow Browser Notifications to get realtime Chat Notifications',
      type: 'info',
      confirmButtonText: 'Allow',
      showCancelButton: true,
      // showCloseButton: true,
      allowOutsideClick: false,
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {
        Notification.requestPermission(function (status) {
          // console.log('Notification permission status:', status);
          if (status == "granted") {
            initServiceWorker();
          } else {
            updateSubscriptionOnServer(null);
          }
        });
      }
    });

  }

}

function initServiceWorker() {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    console.log('Service Worker and Push is supported');

    navigator.serviceWorker.register('/static/js/serviceworker.js')
      .then(function (swReg) {
        swRegistration = swReg;
        swReg.update();

        var serviceWorker;

        if (swReg.installing) {
          serviceWorker = swReg.installing;
          // console.log('Service worker installing');
        } else if (swReg.waiting) {
          serviceWorker = swReg.waiting;
          // console.log('Service worker installed & waiting');
        } else if (swReg.active) {
          serviceWorker = swReg.active;
          // console.log('Service worker active');
        }

        if (serviceWorker) {
          // console.log("sw current state", serviceWorker.state);
          if (serviceWorker.state == "activated") {
            //If push subscription wasnt done yet have to do here
            // console.log("sw already activated - Do watever needed here");
            initializeUI();
          }
          serviceWorker.addEventListener("statechange", function (e) {
            // console.log("sw statechange : ", e.target.state);
            if (e.target.state == "activated") {
              // use pushManger for subscribing here.
              //console.log("Just now activated. now we can subscribe for push notification")
              // subscribeForPushNotification(reg);
              initializeUI();
            }
          });
        }
        // console.log('Service Worker is registered', swReg);
      })
      .catch(function (error) {
        console.error('Service Worker Error', error);
      });
    //created broadcast channel
    const broadcast = new BroadcastChannel('notifychat');

    //this is listening message from service worker once service worker publish message it will recieved 
    //here
    //realod page with url got from service worker
    broadcast.onmessage = (event) => {
      // console.log(event.data);
      window.location.href = event.data.payload;
    };
  } else {
    console.warn('Push messaging is not supported');
  }
}

function initializeUI() {
  subscribeUser();

  // Set the initial subscription value
  swRegistration.pushManager.getSubscription()
    .then(function (subscription) {
      isSubscribed = !(subscription === null);

      updateSubscriptionOnServer(subscription);

      if (isSubscribed) {
        // console.log('User IS subscribed.');
      } else {
        // console.log('User is NOT subscribed.');
      }

    });
}

function subscribeUser() {
  const applicationServerKey = urlB64ToUint8Array(process.env.APPLICATION_SERVER_KEY);
  swRegistration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: applicationServerKey
  })
    .then(function (subscription) {
      console.log('User is subscribed.');

      updateSubscriptionOnServer(subscription);

      isSubscribed = true;

    })
    .catch(function (err) {
      console.log('Failed to subscribe the user: ', err);
    });
}

function updateSubscriptionOnServer(subscription) {

  if (subscription) {
    //subscriptionJson.textContent = JSON.stringify(subscription);
    sendSubscriptionToServer(JSON.stringify(subscription));
    //subscriptionDetails.classList.remove('is-invisible');
  } else {

  }
}

function sendSubscriptionToServer(subscription) {

  var fields = {
    'subscription': subscription,
  };

  var config = {
    headers: { Authorization: "Bearer " + localStorage.getItem("tkn") }
  };

  HTTP.post("browser/subscription", fields, config)
    .then(function (data) {
      // console.log(JSON.stringify(data.data));
    })
    .catch(function (error) {
      // console.log(error);
    })
}

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}



// WEBPACK FOOTER //
// ./src/main.js